import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { bulkUpdateOrderStatus } from "../../api/apiOrders";
import parseError from "../../utils/parseError";

export const useBulkUpdateOrderStatus = () => {
    const queryClient = useQueryClient();

    const { mutate: bulkUpdateStatusMutate, isPending: isBulkUpdating } = useMutation({
        mutationFn: bulkUpdateOrderStatus,
        onSuccess: (res) => {
            const data = res?.data || {};
            const updated = data.updated?.length || 0;
            const failed  = data.failed?.length || 0;
            toast.success(
                res.message ||
                `Updated ${updated}${failed ? `, ${failed} failed` : ''}`
            );
            queryClient.invalidateQueries(["orders"]);
        },
        onError: (error) => {
            toast.error(parseError(error) || "Bulk update failed");
        },
    });

    return { bulkUpdateStatusMutate, isBulkUpdating };
};
